module.exports = "/_next/static/images/6b6588cbfc9b58179100654f86aa649b-apple-pay.png";